import {
  ABOUT_STATE,
  HOW_IT_WORKS_STATE,
  INITIAL_PAGE_STATE,
  REPORT_PAGE_STATE,
  NEW_LOGIN_STATE,
  MANAGE_STATE,
  LOGIN_STATE,
  REMEDIATIONS_STATE,
  LST_UPGRADE,
  ADDONS_SETTINGS_STATE,
  FORGOT_PASSWORD_STATE,
  RECOVERY_STATE,
} from 'constants/constants';
import { Trigger } from 'types/trigger';
import { Views } from './types';

interface UseInitialPageViewParams {
  page: string;
  trigger: Trigger;
  isWidgetReady: boolean;
  isLogged: boolean;
}

export const getInitialPageView = ({
  page,
  trigger,
  isWidgetReady,
  isLogged,
}: UseInitialPageViewParams): Views | null => {
  // First check for manage-skeleton page condition
  if (!isWidgetReady) {
    return Views.SkeletonPage;
  }

  switch (page) {
    case INITIAL_PAGE_STATE:
      return trigger === Trigger.Lst ? Views.InitialPageLst : Views.InitialPage;

    case REPORT_PAGE_STATE:
      return Views.ReportPage;

    case ABOUT_STATE:
      return Views.AboutPage;

    case HOW_IT_WORKS_STATE:
      return Views.HowItWorksPage;

    case NEW_LOGIN_STATE:
      // if user is logged in, it loads the Manage page, else the new login page
      return isLogged ? Views.Manage : Views.Login;

    case LOGIN_STATE: {
      // if user is logged in, it loads the Manage page, else the old login page
      return isLogged ? Views.Manage : null;
    }

    case FORGOT_PASSWORD_STATE:
      return Views.ForgotPassword;

    case RECOVERY_STATE:
      return Views.Recovery;

    case MANAGE_STATE:
      return Views.Manage;

    case LST_UPGRADE:
      return Views.LstUpgrade;

    case REMEDIATIONS_STATE:
      return Views.Remediations;

    case ADDONS_SETTINGS_STATE:
      return Views.AddonsAndSettings;
    default:
      return null;
  }
};
